// Where to send someone after sign-in. Only same-site paths, so ?next= can't
// bounce users off-site ("//evil.com" is protocol-relative, hence the second
// check). Used by both proxy.ts and the sign-in page.
export function safeNextPath(next: string | null | undefined): string {
  return next && next.startsWith("/") && !next.startsWith("//") ? next : "/app";
}
